import React, { useEffect, useState } from 'react';
import { stockValorisationService } from '../../api/services';
import { StockValorisation as Data } from '../../types';
import { MoneyDisplay } from '../../components/common/MoneyDisplay';
import { LoadingSpinner } from '../../components/common/LoadingSpinner';

/**
 * Valorisation du stock (TF-025) au CMUP, avec CO₂ dormant.
 */
export function StockValorisation() {
  const [data, setData] = useState<Data | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    stockValorisationService.get().then(setData).finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="page-title">Valorisation du stock</h1>
        <p className="page-subtitle">Valeur au CMUP et empreinte carbone dormante</p>
      </div>

      {data && (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="card"><p className="text-sm text-gray-500">Valeur totale du stock</p>
              <MoneyDisplay amount={data.totalValeur} className="text-2xl font-bold" /></div>
            <div className="card"><p className="text-sm text-gray-500">CO₂ dormant</p>
              <p className="text-2xl font-bold text-green-700">{data.totalCo2Kg.toFixed(1)} kg</p></div>
          </div>

          <div className="card overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50"><tr className="text-left text-xs font-medium text-gray-500 uppercase">
                <th className="px-4 py-2">Article</th>
                <th className="px-4 py-2 text-right">Stock</th>
                <th className="px-4 py-2 text-right">CMUP</th>
                <th className="px-4 py-2 text-right">Valeur</th>
                <th className="px-4 py-2 text-right">CO₂ (kg)</th>
              </tr></thead>
              <tbody className="divide-y divide-gray-100">
                {data.lignes.length === 0 && (
                  <tr><td colSpan={5} className="px-4 py-6 text-center text-gray-400">Stock vide.</td></tr>
                )}
                {data.lignes.map((l) => (
                  <tr key={l.articleId}>
                    <td className="px-4 py-2">
                      {l.designation}{l.enRupture && <span className="ml-2 text-xs text-red-600">⚠ rupture</span>}
                    </td>
                    <td className="px-4 py-2 text-right">{l.stockActuel}</td>
                    <td className="px-4 py-2 text-right"><MoneyDisplay amount={l.cmup} size="sm" /></td>
                    <td className="px-4 py-2 text-right font-medium"><MoneyDisplay amount={l.valeur} size="sm" /></td>
                    <td className="px-4 py-2 text-right">{l.co2Kg == null ? '—' : l.co2Kg.toFixed(1)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

export default StockValorisation;
